import { IonRouterOutlet, IonTabBar, IonTabs, IonTabButton } from '@ionic/react';
import { createSelector } from '@reduxjs/toolkit';
import { personAdd, personRemove, search } from 'ionicons/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router-dom';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import Check from '@pages/Check';
import { CheckAction, CheckType } from '@pages/Check/Enums';
import { generateRoute } from '@services/navigation-service';
import { getCheckOutEnabled, getKioskModeEnabled, getSearchEmailEnabled } from '@state/event';
import { getSessionInfo } from '@state/session';
import { Capacitor } from '~capacitor-plugins/core';

import { Icon, Label, Tabs } from '../Event/Tabs';

const selector = createSelector(
  getCheckOutEnabled,
  getSearchEmailEnabled,
  getKioskModeEnabled,
  getSessionInfo,
  (checkOutEnabled, searchEmailEnabled, kioskModeEnabled, session) => ({
    checkOutEnabled,
    searchEmailEnabled,
    kioskModeEnabled,
    sessionId: session?.id,
  })
);
const SessionTabs = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const { checkOutEnabled, searchEmailEnabled, sessionId } = useSelector(selector);

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path={generateRoute(RoutePath.SessionCheck)} exact>
          <Check type={CheckType.Scanner} />
        </Route>
        <Route path={generateRoute(RoutePath.SessionPeopleSearch)} exact>
          <Check type={CheckType.Manual} />
        </Route>
      </IonRouterOutlet>
      <IonTabBar slot="bottom">
        {Capacitor.isNativePlatform() && (
          <IonTabButton
            tab={Tabs.CheckIn}
            href={generateRoute(RoutePath.SessionCheck, {
              eventId,
              sessionId,
              action: CheckAction.CheckIn,
            })}
          >
            <Icon icon={personAdd} />
            <Label>{t`Check In`}</Label>
          </IonTabButton>
        )}
        {Capacitor.isNativePlatform() && checkOutEnabled && (
          <IonTabButton
            tab={Tabs.CheckOut}
            href={generateRoute(RoutePath.SessionCheck, {
              eventId,
              sessionId,
              action: CheckAction.CheckOut,
            })}
          >
            <Icon icon={personRemove} />
            <Label>{t`Check Out`}</Label>
          </IonTabButton>
        )}
        {searchEmailEnabled && (
          <IonTabButton
            tab={Tabs.Search}
            href={generateRoute(RoutePath.SessionPeopleSearch, { eventId, sessionId })}
          >
            <Icon icon={search} />
            <Label>{t`Search`}</Label>
          </IonTabButton>
        )}
      </IonTabBar>
    </IonTabs>
  );
};

export default SessionTabs;
